// Version : 0.0.1
// Author : AGALYA

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/************** GET PROGRESS REPORT START ********************** */
export const getProgressReport = (branchData: any) => {
	const data = {
		GetBranchProgressListToken: branchData,
	};
	const url = `${API_URL}getProgressReport`;
	return makeApiCall(url, data);
};
/************** GET PROGRESS REPORT END ********************** */
